var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor send-waba-template-message" },
    [
      _c(
        "a-spin",
        { staticClass: "spinner", attrs: { spinning: _vm.loading } },
        [
          _c(
            "div",
            { staticClass: "editor-row" },
            [
              _c("div", { staticClass: "editor-row-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.sendWhatsappTemplateMessageSonuGeleneKadarBekle"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("a-switch", {
                model: {
                  value: _vm.clone.waitForResponse,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "waitForResponse", $$v)
                  },
                  expression: "clone.waitForResponse",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clone.waitForResponse
            ? _c(
                "div",
                { staticClass: "editor-row" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "auto.sendWhatsappTemplateMessageBeklemeSResiSaniye"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-input-number", {
                    attrs: { min: 30, max: 600 },
                    model: {
                      value: _vm.clone.waitTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "waitTime", $$v)
                      },
                      expression: "clone.waitTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "editor-row" },
            [
              _c("div", { staticClass: "editor-row-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("auto.sendWhatsappTemplateMessageChannel"))
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "classic-new-select",
                  attrs: {
                    placeholder: _vm.$t(
                      "auto.sendWhatsappTemplateMessageWhatsappBusinessChannel"
                    ),
                  },
                  model: {
                    value: _vm.clone.channelId,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "channelId", $$v)
                    },
                    expression: "clone.channelId",
                  },
                },
                _vm._l(_vm.businessChannels, function (channel) {
                  return _c(
                    "a-select-option",
                    { key: channel._id, attrs: { value: channel._id } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(channel.name) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSupsisWabaChannel && _vm.isMmliteSendChoiceAvailable
            ? _c("div", { staticClass: "editor-row mmlite-block-row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "mmlite-broadcast-block mmlite-broadcast-block--compact",
                  },
                  [
                    _c("div", { staticClass: "mmlite-broadcast-header" }, [
                      _c("h4", { staticClass: "mmlite-broadcast-heading" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "whatsapp_business_api.mmLiteBlockSectionTitle"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mmlite-broadcast-cards",
                        attrs: {
                          role: "radiogroup",
                          "aria-label": _vm.$t(
                            "whatsapp_business_api.mmLiteBlockSectionTitle"
                          ),
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "mmlite-broadcast-card mmlite-broadcast-card--with-badge",
                            class: {
                              "mmlite-broadcast-card--active":
                                _vm.clone.sendTemplateViaMmlite !== false,
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.clone.sendTemplateViaMmlite = true
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "mmlite-broadcast-card-badge" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "whatsapp_business_api.mmLiteBroadcastBadgeRecommended"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "mmlite-broadcast-card-title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "whatsapp_business_api.mmLiteBroadcastOptionRecommendedTitle"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "mmlite-broadcast-card-text" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "whatsapp_business_api.mmLiteBroadcastOptionRecommendedBody"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "mmlite-broadcast-card",
                            class: {
                              "mmlite-broadcast-card--active":
                                _vm.clone.sendTemplateViaMmlite === false,
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.clone.sendTemplateViaMmlite = false
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "mmlite-broadcast-card-title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "whatsapp_business_api.mmLiteBroadcastOptionStandardTitle"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "mmlite-broadcast-card-text" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "whatsapp_business_api.mmLiteBroadcastOptionStandardBody"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isSupsisWabaChannel && !_vm.isMmliteSendChoiceAvailable
            ? _c("div", { staticClass: "editor-row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "editor-hint mmlite-hint mmlite-block-not-onboarded",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "whatsapp_business_api.mmLiteBlockNotOnboardedHint"
                        )
                      )
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.clone.channelId
            ? _c(
                "div",
                { staticClass: "editor-row" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("auto.sendWhatsappTemplateMessageTemplate")
                        ) +
                        "\n                "
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            _vm.previewMode = true
                          },
                        },
                      },
                      [_vm._v("visibility")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticClass: "classic-new-select",
                      attrs: {
                        placeholder: _vm.$t(
                          "auto.sendWhatsappTemplateMessageWhatsappBusinessChannel"
                        ),
                        value: _vm.selectedTemplateId,
                      },
                      on: { change: _vm.selectTemplate },
                    },
                    _vm._l(_vm.templates, function (template, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: template.id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(template.elementName || template.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTemplateId
            ? _c(
                "div",
                { staticClass: "editor-row" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "auto.sendWhatsappTemplateMessageWhatsappPhoneNumber"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("TiptapEditor", {
                    attrs: {
                      placeholder: "Whatsapp Phone Number",
                      "show-attributes": true,
                      "max-character-count": 500,
                      "automation-mode": "",
                    },
                    model: {
                      value: _vm.clone.phoneNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "phoneNumber", $$v)
                      },
                      expression: "clone.phoneNumber",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#666",
                        "margin-top": "4px",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              "auto.sendWhatsappTemplateMessageSabitDeErGireceksenizLkeKodunuDaGirmenizGerekmektedirRn905551234567"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isMetaFormat && _vm.selectedTemplateId
            ? _c("div", { staticClass: "meta-template-config" }, [
                _c("div", { staticClass: "config-layout" }, [
                  _c(
                    "div",
                    { staticClass: "config-area" },
                    [
                      _c("div", { staticClass: "meta-block" }, [
                        _c("div", { staticClass: "meta-item" }, [
                          _c("span", { staticClass: "meta-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "auto.sendWhatsappTemplateMessageTemplate"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "meta-value" }, [
                            _vm._v(_vm._s(_vm.clone.template.name)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "meta-item" }, [
                          _c("span", { staticClass: "meta-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "auto.sendWhatsappTemplateMessageCategory"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "meta-value meta-tag" }, [
                            _vm._v(_vm._s(_vm.clone.template.category)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "meta-item" }, [
                          _c("span", { staticClass: "meta-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "auto.sendWhatsappTemplateMessageLanguage"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "meta-value" }, [
                            _vm._v(_vm._s(_vm.clone.template.language)),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.isCarousel
                        ? _c("div", { staticClass: "tabs-container" }, [
                            _c(
                              "div",
                              { staticClass: "tabs-header" },
                              _vm._l(_vm.carouselTabs, function (tab, idx) {
                                return _c(
                                  "div",
                                  {
                                    key: idx,
                                    staticClass: "tab-item",
                                    class: { active: _vm.activeTab === idx },
                                    on: {
                                      click: function ($event) {
                                        _vm.activeTab = idx
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(tab) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isCarousel
                        ? [
                            _vm.hasMediaHeader
                              ? _c("div", { staticClass: "config-block" }, [
                                  _c("div", { staticClass: "block-header" }, [
                                    _c("span", { staticClass: "block-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "auto.sendWhatsappTemplateMessageHeader"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "block-hint" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "auto.sendWhatsappTemplateMessageRequired"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "media-source-selection" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "radio-option" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.mediaType,
                                                expression: "mediaType",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              value: "static",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.mediaType,
                                                "static"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.mediaType = "static"
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "auto.sendWhatsappTemplateMessageUploadMedia"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { staticClass: "radio-option" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.mediaType,
                                                expression: "mediaType",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              value: "dynamic",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.mediaType,
                                                "dynamic"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.mediaType = "dynamic"
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "auto.sendWhatsappTemplateMessageUseUrl"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.mediaType === "dynamic"
                                    ? _c(
                                        "div",
                                        { staticClass: "media-url-input" },
                                        [
                                          _c("TiptapEditor", {
                                            attrs: {
                                              placeholder:
                                                "Enter URL or select attribute",
                                              "show-attributes": true,
                                              "max-character-count": 500,
                                              "automation-mode": "",
                                              value: _vm.externalUrl,
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.externalUrl = $event
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c("div", { staticClass: "media-area" }, [
                                        _vm.media
                                          ? _c(
                                              "div",
                                              { staticClass: "media-uploaded" },
                                              [
                                                _vm.metaHeaderComponent
                                                  .format === "IMAGE"
                                                  ? _c("img", {
                                                      attrs: {
                                                        src: _vm.media.data,
                                                        alt: _vm.$t(
                                                          "auto.sendWhatsappTemplateMessagePreview"
                                                        ),
                                                      },
                                                    })
                                                  : _vm.metaHeaderComponent
                                                      .format === "VIDEO"
                                                  ? _c("video", {
                                                      attrs: {
                                                        src: _vm.media.data,
                                                        controls: "",
                                                      },
                                                    })
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "doc-preview",
                                                      },
                                                      [
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "file",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.media.name
                                                            )
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "remove-media",
                                                    on: {
                                                      click: _vm.deleteMedia,
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "close" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "label",
                                              { staticClass: "upload-area" },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "file",
                                                    accept: _vm.getAcceptType(),
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.handleFileUpload,
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("a-icon", {
                                                  attrs: {
                                                    type: "cloud-upload",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "upload-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "auto.sendWhatsappTemplateMessageClickToUpload"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "upload-format",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.getMediaHint())
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                      ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.metaHeaderComponent &&
                            _vm.metaHeaderComponent.format === "TEXT" &&
                            _vm.metaHeaderParams.length > 0
                              ? _c("div", { staticClass: "config-block" }, [
                                  _c("div", { staticClass: "block-header" }, [
                                    _c("span", { staticClass: "block-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "auto.sendWhatsappTemplateMessageHeaderVariables"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "params-list" },
                                    _vm._l(
                                      _vm.metaHeaderParams,
                                      function (param, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: "h-" + index,
                                            staticClass: "param-row",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "param-info" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "param-idx" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getPlaceholder(
                                                          index
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "param-ctx" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getParamContext(
                                                          _vm
                                                            .metaHeaderComponent
                                                            .text,
                                                          index
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "param-controls" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "param-mode-selection",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "mode-option",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .headerParamModes[
                                                                  index
                                                                ],
                                                              expression:
                                                                "headerParamModes[index]",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            value: "static",
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm
                                                                .headerParamModes[
                                                                index
                                                              ],
                                                              "static"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.headerParamModes,
                                                                index,
                                                                "static"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "auto.sendWhatsappTemplateMessageStatic"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "mode-option",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .headerParamModes[
                                                                  index
                                                                ],
                                                              expression:
                                                                "headerParamModes[index]",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            value: "dynamic",
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm
                                                                .headerParamModes[
                                                                index
                                                              ],
                                                              "dynamic"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.headerParamModes,
                                                                index,
                                                                "dynamic"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "auto.sendWhatsappTemplateMessageDinamik"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.headerParamModes[index] ===
                                                "static"
                                                  ? _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .metaHeaderParams[
                                                              index
                                                            ],
                                                          expression:
                                                            "metaHeaderParams[index]",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "param-field",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "auto.sendWhatsappTemplateMessageEnterValue"
                                                        ),
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.metaHeaderParams[
                                                            index
                                                          ],
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.metaHeaderParams,
                                                            index,
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _c("TiptapEditor", {
                                                      attrs: {
                                                        placeholder:
                                                          "Select or type attribute",
                                                        "show-attributes": true,
                                                        "max-character-count": 500,
                                                        "automation-mode": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.metaHeaderParams[
                                                            index
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.metaHeaderParams,
                                                            index,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "metaHeaderParams[index]",
                                                      },
                                                    }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.metaBodyParams.length > 0
                              ? _c("div", { staticClass: "config-block" }, [
                                  _c("div", { staticClass: "block-header" }, [
                                    _c("span", { staticClass: "block-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "auto.sendWhatsappTemplateMessageBodyVariables"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "params-list" },
                                    _vm._l(
                                      _vm.metaBodyParams,
                                      function (param, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: "b-" + index,
                                            staticClass: "param-row",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "param-info" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "param-idx" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getPlaceholder(
                                                          index
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "param-ctx" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getParamContext(
                                                          _vm.metaBodyComponent
                                                            .text,
                                                          index
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "param-controls" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "param-mode-selection",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "mode-option",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .bodyParamModes[
                                                                  index
                                                                ],
                                                              expression:
                                                                "bodyParamModes[index]",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            value: "static",
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm
                                                                .bodyParamModes[
                                                                index
                                                              ],
                                                              "static"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.bodyParamModes,
                                                                index,
                                                                "static"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "auto.sendWhatsappTemplateMessageStatic"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "mode-option",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .bodyParamModes[
                                                                  index
                                                                ],
                                                              expression:
                                                                "bodyParamModes[index]",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            value: "dynamic",
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm
                                                                .bodyParamModes[
                                                                index
                                                              ],
                                                              "dynamic"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.bodyParamModes,
                                                                index,
                                                                "dynamic"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "auto.sendWhatsappTemplateMessageDinamik"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.bodyParamModes[index] ===
                                                "static"
                                                  ? _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.metaBodyParams[
                                                              index
                                                            ],
                                                          expression:
                                                            "metaBodyParams[index]",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "param-field",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "auto.sendWhatsappTemplateMessageEnterValue"
                                                        ),
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.metaBodyParams[
                                                            index
                                                          ],
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.metaBodyParams,
                                                            index,
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _c("TiptapEditor", {
                                                      attrs: {
                                                        placeholder:
                                                          "Select or type attribute",
                                                        "show-attributes": true,
                                                        "max-character-count": 500,
                                                        "automation-mode": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.metaBodyParams[
                                                            index
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.metaBodyParams,
                                                            index,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "metaBodyParams[index]",
                                                      },
                                                    }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.metaButtonParams.length > 0
                              ? _c("div", { staticClass: "config-block" }, [
                                  _c("div", { staticClass: "block-header" }, [
                                    _c("span", { staticClass: "block-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "auto.sendWhatsappTemplateMessageButtonVariables"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "params-list" },
                                    _vm._l(
                                      _vm.metaButtonParams,
                                      function (param, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: "btn-" + index,
                                            staticClass: "param-row",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "param-info" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "param-idx" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getPlaceholder(
                                                          index
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "param-ctx" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getButtonParamContext(
                                                          index
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "param-controls" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "param-mode-selection",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "mode-option",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .buttonParamModes[
                                                                  index
                                                                ],
                                                              expression:
                                                                "buttonParamModes[index]",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            value: "static",
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm
                                                                .buttonParamModes[
                                                                index
                                                              ],
                                                              "static"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.buttonParamModes,
                                                                index,
                                                                "static"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "auto.sendWhatsappTemplateMessageStatic"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "mode-option",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .buttonParamModes[
                                                                  index
                                                                ],
                                                              expression:
                                                                "buttonParamModes[index]",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            value: "dynamic",
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm
                                                                .buttonParamModes[
                                                                index
                                                              ],
                                                              "dynamic"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.buttonParamModes,
                                                                index,
                                                                "dynamic"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "auto.sendWhatsappTemplateMessageDinamik"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.buttonParamModes[index] ===
                                                "static"
                                                  ? _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .metaButtonParams[
                                                              index
                                                            ],
                                                          expression:
                                                            "metaButtonParams[index]",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "param-field",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "auto.sendWhatsappTemplateMessageEnterValue"
                                                        ),
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.metaButtonParams[
                                                            index
                                                          ],
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.metaButtonParams,
                                                            index,
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _c("TiptapEditor", {
                                                      attrs: {
                                                        placeholder:
                                                          "Select or type attribute",
                                                        "show-attributes": true,
                                                        "max-character-count": 500,
                                                        "automation-mode": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.metaButtonParams[
                                                            index
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.metaButtonParams,
                                                            index,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "metaButtonParams[index]",
                                                      },
                                                    }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.hasAnyMetaParams && !_vm.hasMediaHeader
                              ? _c("div", { staticClass: "ready-state" }, [
                                  _c(
                                    "div",
                                    { staticClass: "ready-icon" },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "check" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ready-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "auto.sendWhatsappTemplateMessageReadyToSend"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ready-hint" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "auto.sendWhatsappTemplateMessageThisTemplateRequiresNoParameters"
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        : [
                            _vm.activeTab === 0
                              ? [
                                  _vm.metaBodyParams.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "config-block" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "block-header" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "block-title" },
                                                [_vm._v("Body Variables")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "params-list" },
                                            _vm._l(
                                              _vm.metaBodyParams,
                                              function (param, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: "mb-" + index,
                                                    staticClass: "param-row",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "param-info",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "param-idx",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getPlaceholder(
                                                                  index
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "param-ctx",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getParamContext(
                                                                  _vm
                                                                    .metaBodyComponent
                                                                    .text,
                                                                  index
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "param-controls",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "param-mode-selection",
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "mode-option",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .bodyParamModes[
                                                                          index
                                                                        ],
                                                                      expression:
                                                                        "bodyParamModes[index]",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "radio",
                                                                    value:
                                                                      "static",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      _vm._q(
                                                                        _vm
                                                                          .bodyParamModes[
                                                                          index
                                                                        ],
                                                                        "static"
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.bodyParamModes,
                                                                          index,
                                                                          "static"
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "Static"
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "mode-option",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .bodyParamModes[
                                                                          index
                                                                        ],
                                                                      expression:
                                                                        "bodyParamModes[index]",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "radio",
                                                                    value:
                                                                      "dynamic",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      _vm._q(
                                                                        _vm
                                                                          .bodyParamModes[
                                                                          index
                                                                        ],
                                                                        "dynamic"
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.bodyParamModes,
                                                                          index,
                                                                          "dynamic"
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "Dinamik"
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.bodyParamModes[
                                                          index
                                                        ] === "static"
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .metaBodyParams[
                                                                      index
                                                                    ],
                                                                  expression:
                                                                    "metaBodyParams[index]",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "param-field",
                                                              attrs: {
                                                                type: "text",
                                                                placeholder:
                                                                  "Enter value",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .metaBodyParams[
                                                                    index
                                                                  ],
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm.metaBodyParams,
                                                                      index,
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            })
                                                          : _c("TiptapEditor", {
                                                              attrs: {
                                                                placeholder:
                                                                  "Select or type attribute",
                                                                "show-attributes": true,
                                                                "max-character-count": 500,
                                                                "automation-mode":
                                                                  "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .metaBodyParams[
                                                                    index
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.metaBodyParams,
                                                                      index,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "metaBodyParams[index]",
                                                              },
                                                            }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.metaBodyParams.length === 0
                                    ? _c(
                                        "div",
                                        { staticClass: "ready-state" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ready-icon" },
                                            [
                                              _c("a-icon", {
                                                attrs: { type: "check" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "ready-text" },
                                            [_vm._v("No variables")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "ready-hint" },
                                            [
                                              _vm._v(
                                                "Main message has no parameters"
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._l(
                                  _vm.carouselCards,
                                  function (card, cardIndex) {
                                    return _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.activeTab === cardIndex + 1,
                                            expression:
                                              "activeTab === cardIndex + 1",
                                          },
                                        ],
                                        key: "card-" + cardIndex,
                                      },
                                      [
                                        _vm.hasCarouselCardHeaderVariable(
                                          cardIndex
                                        )
                                          ? _c(
                                              "div",
                                              { staticClass: "config-block" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "block-header",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "block-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Header " +
                                                            _vm._s(
                                                              _vm.getCarouselCardHeaderFormat(
                                                                cardIndex
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "block-hint",
                                                      },
                                                      [_vm._v("Required")]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "media-source-selection",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "radio-option",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .carouselCardUseUrl[
                                                                  cardIndex
                                                                ],
                                                              expression:
                                                                "carouselCardUseUrl[cardIndex]",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                          },
                                                          domProps: {
                                                            value: false,
                                                            checked: _vm._q(
                                                              _vm
                                                                .carouselCardUseUrl[
                                                                cardIndex
                                                              ],
                                                              false
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.carouselCardUseUrl,
                                                                cardIndex,
                                                                false
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            "Upload Media"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "radio-option",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .carouselCardUseUrl[
                                                                  cardIndex
                                                                ],
                                                              expression:
                                                                "carouselCardUseUrl[cardIndex]",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                          },
                                                          domProps: {
                                                            value: true,
                                                            checked: _vm._q(
                                                              _vm
                                                                .carouselCardUseUrl[
                                                                cardIndex
                                                              ],
                                                              true
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.carouselCardUseUrl,
                                                                cardIndex,
                                                                true
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v("Use URL"),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.carouselCardUseUrl[
                                                  cardIndex
                                                ]
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "media-url-input",
                                                      },
                                                      [
                                                        _c("TiptapEditor", {
                                                          attrs: {
                                                            placeholder:
                                                              "Enter URL or select attribute",
                                                            "show-attributes": true,
                                                            "max-character-count": 500,
                                                            "automation-mode":
                                                              "",
                                                            value:
                                                              _vm
                                                                .carouselCardParams[
                                                                cardIndex
                                                              ].header[0],
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.setCarouselCardHeaderParam(
                                                                cardIndex,
                                                                0,
                                                                $event
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "media-area",
                                                      },
                                                      [
                                                        _vm.carouselCardMedia[
                                                          cardIndex
                                                        ]
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "media-uploaded",
                                                              },
                                                              [
                                                                _vm.getCarouselCardHeaderFormat(
                                                                  cardIndex
                                                                ) === "IMAGE"
                                                                  ? _c("img", {
                                                                      attrs: {
                                                                        src: _vm
                                                                          .carouselCardMedia[
                                                                          cardIndex
                                                                        ].data,
                                                                        alt: "Preview",
                                                                      },
                                                                    })
                                                                  : _vm.getCarouselCardHeaderFormat(
                                                                      cardIndex
                                                                    ) ===
                                                                    "VIDEO"
                                                                  ? _c(
                                                                      "video",
                                                                      {
                                                                        attrs: {
                                                                          src: _vm
                                                                            .carouselCardMedia[
                                                                            cardIndex
                                                                          ]
                                                                            .data,
                                                                          controls:
                                                                            "",
                                                                        },
                                                                      }
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "doc-preview",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                type: "file",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .carouselCardMedia[
                                                                                  cardIndex
                                                                                ]
                                                                                  .name
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "remove-media",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removeCarouselCardMedia(
                                                                            cardIndex
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a-icon",
                                                                      {
                                                                        attrs: {
                                                                          type: "close",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "upload-area",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  attrs: {
                                                                    type: "file",
                                                                    accept:
                                                                      _vm.getCarouselCardAcceptType(
                                                                        cardIndex
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleCarouselCardFileUpload(
                                                                          $event,
                                                                          cardIndex
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("a-icon", {
                                                                  attrs: {
                                                                    type: "cloud-upload",
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "upload-label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Click to upload"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "upload-format",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.getCarouselCardMediaHint(
                                                                          cardIndex
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.carouselCardParams[cardIndex].body
                                          .length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "config-block" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "block-header",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "block-title",
                                                      },
                                                      [_vm._v("Body Variables")]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "params-list",
                                                  },
                                                  _vm._l(
                                                    _vm.carouselCardParams[
                                                      cardIndex
                                                    ].body,
                                                    function (
                                                      param,
                                                      paramIndex
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key:
                                                            "cb-" + paramIndex,
                                                          staticClass:
                                                            "param-row",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "param-info",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "param-idx",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getPlaceholder(
                                                                        paramIndex
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "param-ctx",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getCarouselCardBodyContext(
                                                                        cardIndex,
                                                                        paramIndex
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "param-controls",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "param-mode-selection",
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "mode-option",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .body[
                                                                                    paramIndex
                                                                                  ],
                                                                                expression:
                                                                                  "carouselCardParamModes[cardIndex].body[paramIndex]",
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              type: "radio",
                                                                              value:
                                                                                "static",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              checked:
                                                                                _vm._q(
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .body[
                                                                                    paramIndex
                                                                                  ],
                                                                                  "static"
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.$set(
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .body,
                                                                                  paramIndex,
                                                                                  "static"
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Static"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "mode-option",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .body[
                                                                                    paramIndex
                                                                                  ],
                                                                                expression:
                                                                                  "carouselCardParamModes[cardIndex].body[paramIndex]",
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              type: "radio",
                                                                              value:
                                                                                "dynamic",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              checked:
                                                                                _vm._q(
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .body[
                                                                                    paramIndex
                                                                                  ],
                                                                                  "dynamic"
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.$set(
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .body,
                                                                                  paramIndex,
                                                                                  "dynamic"
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Dinamik"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm
                                                                .carouselCardParamModes[
                                                                cardIndex
                                                              ].body[
                                                                paramIndex
                                                              ] === "static"
                                                                ? _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .carouselCardParams[
                                                                              cardIndex
                                                                            ]
                                                                              .body[
                                                                              paramIndex
                                                                            ],
                                                                          expression:
                                                                            "carouselCardParams[cardIndex].body[paramIndex]",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "param-field",
                                                                    attrs: {
                                                                      type: "text",
                                                                      placeholder:
                                                                        "Enter value",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .carouselCardParams[
                                                                          cardIndex
                                                                        ].body[
                                                                          paramIndex
                                                                        ],
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .carouselCardParams[
                                                                              cardIndex
                                                                            ]
                                                                              .body,
                                                                            paramIndex,
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _c(
                                                                    "TiptapEditor",
                                                                    {
                                                                      attrs: {
                                                                        placeholder:
                                                                          "Select or type attribute",
                                                                        "show-attributes": true,
                                                                        "max-character-count": 500,
                                                                        "automation-mode":
                                                                          "",
                                                                        value:
                                                                          _vm
                                                                            .carouselCardParams[
                                                                            cardIndex
                                                                          ]
                                                                            .body[
                                                                            paramIndex
                                                                          ],
                                                                      },
                                                                      on: {
                                                                        input:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.setCarouselCardBodyParam(
                                                                              cardIndex,
                                                                              paramIndex,
                                                                              $event
                                                                            )
                                                                          },
                                                                      },
                                                                    }
                                                                  ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.carouselCardParams[cardIndex]
                                          .buttons.length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "config-block" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "block-header",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "block-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Button Variables"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "params-list",
                                                  },
                                                  _vm._l(
                                                    _vm.carouselCardParams[
                                                      cardIndex
                                                    ].buttons,
                                                    function (
                                                      param,
                                                      paramIndex
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key:
                                                            "cbtn-" +
                                                            paramIndex,
                                                          staticClass:
                                                            "param-row",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "param-info",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "param-idx",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getPlaceholder(
                                                                        paramIndex
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "param-ctx",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "URL suffix"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "param-controls",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "param-mode-selection",
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "mode-option",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .buttons[
                                                                                    paramIndex
                                                                                  ],
                                                                                expression:
                                                                                  "carouselCardParamModes[cardIndex].buttons[paramIndex]",
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              type: "radio",
                                                                              value:
                                                                                "static",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              checked:
                                                                                _vm._q(
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .buttons[
                                                                                    paramIndex
                                                                                  ],
                                                                                  "static"
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.$set(
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .buttons,
                                                                                  paramIndex,
                                                                                  "static"
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Static"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "mode-option",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .buttons[
                                                                                    paramIndex
                                                                                  ],
                                                                                expression:
                                                                                  "carouselCardParamModes[cardIndex].buttons[paramIndex]",
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              type: "radio",
                                                                              value:
                                                                                "dynamic",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              checked:
                                                                                _vm._q(
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .buttons[
                                                                                    paramIndex
                                                                                  ],
                                                                                  "dynamic"
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.$set(
                                                                                  _vm
                                                                                    .carouselCardParamModes[
                                                                                    cardIndex
                                                                                  ]
                                                                                    .buttons,
                                                                                  paramIndex,
                                                                                  "dynamic"
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Dinamik"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm
                                                                .carouselCardParamModes[
                                                                cardIndex
                                                              ].buttons[
                                                                paramIndex
                                                              ] === "static"
                                                                ? _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .carouselCardParams[
                                                                              cardIndex
                                                                            ]
                                                                              .buttons[
                                                                              paramIndex
                                                                            ],
                                                                          expression:
                                                                            "carouselCardParams[cardIndex].buttons[paramIndex]",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "param-field",
                                                                    attrs: {
                                                                      type: "text",
                                                                      placeholder:
                                                                        "Enter value",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .carouselCardParams[
                                                                          cardIndex
                                                                        ]
                                                                          .buttons[
                                                                          paramIndex
                                                                        ],
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .carouselCardParams[
                                                                              cardIndex
                                                                            ]
                                                                              .buttons,
                                                                            paramIndex,
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _c(
                                                                    "TiptapEditor",
                                                                    {
                                                                      attrs: {
                                                                        placeholder:
                                                                          "Select or type attribute",
                                                                        "show-attributes": true,
                                                                        "max-character-count": 500,
                                                                        "automation-mode":
                                                                          "",
                                                                        value:
                                                                          _vm
                                                                            .carouselCardParams[
                                                                            cardIndex
                                                                          ]
                                                                            .buttons[
                                                                            paramIndex
                                                                          ],
                                                                      },
                                                                      on: {
                                                                        input:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.setCarouselCardButtonParam(
                                                                              cardIndex,
                                                                              paramIndex,
                                                                              $event
                                                                            )
                                                                          },
                                                                      },
                                                                    }
                                                                  ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.carouselCardParams[cardIndex].header
                                          .length === 0 &&
                                        _vm.carouselCardParams[cardIndex].body
                                          .length === 0 &&
                                        _vm.carouselCardParams[cardIndex]
                                          .buttons.length === 0
                                          ? _c(
                                              "div",
                                              { staticClass: "ready-state" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "ready-icon" },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "check" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "ready-text" },
                                                  [_vm._v("No variables")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "ready-hint" },
                                                  [
                                                    _vm._v(
                                                      "This card has no parameters"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "preview-area" },
                    [
                      _c("WhatsappMessagePreview", {
                        attrs: {
                          templateType: _vm.previewTemplateType,
                          headerMediaType: _vm.previewHeaderMediaType,
                          headerMediaURL: _vm.previewHeaderMediaURL,
                          headerText: _vm.previewHeaderText,
                          body: _vm.previewBody,
                          footer: _vm.previewFooter,
                          buttons: _vm.previewButtons,
                          cards: _vm.previewCards,
                          limitedTimeOffer: _vm.previewLimitedTimeOffer,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm.selectedTemplateId && _vm.variables.length > 0
            ? _c(
                "div",
                { staticClass: "wpa-variables" },
                _vm._l(_vm.variables, function (variable, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "editor-row" },
                    [
                      _c("div", { staticClass: "editor-row-title" }, [
                        _vm._v("Variable (#" + _vm._s(index + 1) + ")"),
                      ]),
                      _vm._v(" "),
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: "Variable (#" + (index + 1) + ")",
                          "show-attributes": true,
                          "max-character-count": 500,
                          "automation-mode": "",
                        },
                        model: {
                          value: _vm.clone.params[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.params, index, $$v)
                          },
                          expression: "clone.params[index]",
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasMediaHeader && !_vm.isMetaFormat
            ? _c("div", { staticClass: "image-picker" }, [
                _c(
                  "div",
                  { staticClass: "editor-row" },
                  [
                    _c("div", { staticClass: "editor-row-title" }, [
                      _vm._v("Media Type"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        attrs: { placeholder: "Select Media Type" },
                        model: {
                          value: _vm.mediaType,
                          callback: function ($$v) {
                            _vm.mediaType = $$v
                          },
                          expression: "mediaType",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "static" } }, [
                          _vm._v("Static"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "dynamic" } }, [
                          _vm._v("Dynamic"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.mediaType === "dynamic"
                      ? _c(
                          "div",
                          [
                            _c("TiptapEditor", {
                              attrs: {
                                placeholder: "Dynamic Media URL",
                                "show-attributes": true,
                                "max-character-count": 500,
                                "automation-mode": "",
                              },
                              model: {
                                value: _vm.externalUrl,
                                callback: function ($$v) {
                                  _vm.externalUrl = $$v
                                },
                                expression: "externalUrl",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mediaType === "static"
                      ? _c("div", [
                          _vm.media
                            ? _c("div", { staticClass: "media-preview" }, [
                                _c(
                                  "div",
                                  { staticClass: "media-preview-content" },
                                  [
                                    _c("div", { staticClass: "media-image" }, [
                                      _c("img", {
                                        attrs: { src: _vm.media.data, alt: "" },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "media-preview-name" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.media.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "media-preview-delete",
                                    on: { click: _vm.deleteMedia },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("delete")]
                                    ),
                                  ]
                                ),
                              ])
                            : _c("div", { staticClass: "media-drag" }, [
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    attrs: {
                                      type: "file",
                                      id: "media-source",
                                      accept: _vm.getAcceptType(),
                                    },
                                    on: { change: _vm.handleFileUpload },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("image"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content" }, [
                                  _vm._v("Click here to upload a picture."),
                                ]),
                              ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _c("div", { staticClass: "input-warn" }, [
                              _c("div", [
                                _c("b", [_vm._v("Note:")]),
                                _vm._v(
                                  " Following are the file formats and their respective sizes which are\n                                accepted for upload\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("ul", { staticClass: "list-item" }, [
                                _c("li", [
                                  _vm._v("Image: JPEG and PNG (Max size 2 MB)"),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v("Video: MP4 (Max size 20 MB)"),
                                ]),
                                _vm._v(" "),
                                _c("li", [_vm._v("Document: (Max size 2 MB)")]),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.clone.template && !_vm.isMetaFormat
        ? _c("WhatsappMessagePreview", {
            attrs: {
              body: _vm.getTemplateParameters(_vm.clone.template).body,
              footer: _vm.getTemplateParameters(_vm.clone.template).footer,
              "header-media-type": _vm.getTemplateParameters(_vm.clone.template)
                .headerType,
              "header-text": _vm.getTemplateParameters(_vm.clone.template)
                .headerText,
              buttons: _vm.getTemplateParameters(_vm.clone.template).buttons,
              headerMediaURL: _vm.getTemplateParameters(_vm.clone.template)
                .headerMediaURL,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }